import { Money as CamelCasedMoney } from '@/api/MyBooking/myBooking.interfaces';
import { formatWithCurrency, formatWithLocale } from '@libs/money/moneyFormatter';
import { CamelCasedMoneyWithCurrencySymbol, Money } from '@libs/money/money.interfaces';
import { getCurrentMarketSpecs } from '@shared/config/market/market.helpers';

// TODO: remove CamelCasedMoneyWithCurrencySymbol and CamelCasedMoney as params.
export function getMoneyObjectAsString(
    value: Money | CamelCasedMoneyWithCurrencySymbol | CamelCasedMoney
): string {
    const market = getCurrentMarketSpecs();
    const valueAsMoney = value as Money;
    const valueAsCamelCaseStuff = value as CamelCasedMoneyWithCurrencySymbol;

    const amount = valueAsMoney.Amount || valueAsCamelCaseStuff.amount || 0;

    return formatWithLocale(amount, market.fullLocale, market.moneyFormat);
}

export function getMoneyAsStringUsingCurrency(value: number, currency: string): string {
    const market = getCurrentMarketSpecs();
    return formatWithCurrency(value, currency, market.fullLocale, market.moneyFormat);
}
